import { render } from "./ModalTarefasSemData.vue?vue&type=template&id=aa08ef94&scoped=true"
import script from "./ModalTarefasSemData.vue?vue&type=script&lang=js"
export * from "./ModalTarefasSemData.vue?vue&type=script&lang=js"

import "./ModalTarefasSemData.vue?vue&type=style&index=0&id=aa08ef94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa08ef94"]])

export default __exports__